import { useTranslation } from "react-i18next";
import { SpellDto, TranslatedText } from "../../../Types/ApiTypes";
import { useEffect, useState } from "react";
import { getAllSpells } from "../../../Utils/LocalApi";
import React from "react";
import { getTranslation } from "../../../Utils/Converters";

interface MonsterSpellGroupComponentProps{
    language: string,
    index: number,
    spellGroup: {
        name: TranslatedText,
        hasSlotsGroup: boolean,
        hasSlotsEach: boolean,
        maxSlots: number,
        spells: SpellDto[]
    },
    updateSpellGroup: (spellGroup: {
        name: TranslatedText,
        hasSlotsGroup: boolean,
        hasSlotsEach: boolean,
        maxSlots: number,
        spells: SpellDto[]
    }) => void
}

const MonsterSpellGroupComponent = (props: MonsterSpellGroupComponentProps)=> {
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState("");
    const [allSpells, setAllSpells] = React.useState<SpellDto[]>([]);
    const [foundSpells, setFoundSpells] = useState([] as SpellDto[]);
    
    useEffect(()=>{
        setSearchValue("");
        getAllSpells().then((value) => {
            let newSpells = [] as SpellDto[];
            value.forEach((element: SpellDto) => {
                newSpells.push(element);
                setAllSpells([...newSpells]);
            });
        });
    },[]);
        
    return(
        <>
            <div className='p-2 d-flex flex-column col-3'>
                <div className="d-flex mt-2 mb-2" >
                    <label className="form-check-label d-flex">    
                        <span>{t("spell-groupname")}&nbsp;&nbsp;</span>
                        <input 
                            value={getTranslation(props.spellGroup.name, props.language)}
                            type="text"
                            className='form-control'
                            style={{maxWidth: "50%"}}
                            placeholder={t("spell-groupname")}
                            onChange={e => {
                                props.spellGroup.name[props.language] = e.target.value;
                                props.updateSpellGroup(props.spellGroup);
                            }}
                        ></input>
                    </label>
                </div>
                <div className="d-flex mt-2 mb-2" >
                    <label className="form-check-label">
                        {t("spell-slottype")}&nbsp;&nbsp;
                        <span className="btn-group" role="group" aria-label="Basic radio toggle button group">
                            <input 
                                type="checkbox" 
                                className="btn-check" 
                                name={props.index+"-btnslottype-none"}
                                id={props.index+"-slottype-none"}
                                autoComplete="off" 
                                checked={!props.spellGroup.hasSlotsEach && !props.spellGroup.hasSlotsGroup} 
                                onChange={e => {
                                        if (e.target.checked){
                                            props.spellGroup.hasSlotsEach = false;
                                            props.spellGroup.hasSlotsGroup = false;
                                            props.updateSpellGroup(props.spellGroup);
                                        }
                                    }
                                }
                            />
                            <label className="btn btn-outline-primary" htmlFor={props.index+"-slottype-none"}>{t("spell-slot-none")}</label>
                            <input 
                                type="checkbox" 
                                className="btn-check" 
                                name={props.index+"-btnslottype-group" }
                                id={props.index+"-slottype-group"}
                                autoComplete="off" 
                                checked={props.spellGroup.hasSlotsGroup} 
                                onChange={e => {
                                        if (e.target.checked){
                                            props.spellGroup.hasSlotsEach = false;
                                            props.spellGroup.hasSlotsGroup = true;
                                            props.updateSpellGroup(props.spellGroup);
                                        }
                                    }
                                }/>
                            <label className="btn btn-outline-primary" htmlFor={props.index+"-slottype-group"}>{t("spell-slot-group")}</label>
                            <input 
                                type="checkbox" 
                                className="btn-check" 
                                name={props.index+"-btnslottype-each" }
                                id={props.index+"-slottype-each"}
                                autoComplete="off" 
                                checked={props.spellGroup.hasSlotsEach} 
                                onChange={e => {
                                    if (e.target.checked){
                                        props.spellGroup.hasSlotsEach = true;
                                        props.spellGroup.hasSlotsGroup = false;
                                        props.updateSpellGroup(props.spellGroup);
                                    }
                                }
                            }/>
                            <label className="btn btn-outline-primary" htmlFor={props.index+"-slottype-each"}>{t("spell-slot-each")}</label>
                        </span>
                    </label>
                </div>
                {(props.spellGroup.hasSlotsGroup || props.spellGroup.hasSlotsEach) && <div className="d-flex  mt-2 mb-2" >
                    <label className="form-check-label">
                        {t("spell-maxslots")}
                    </label>
                    &nbsp;&nbsp;
                    <input 
                        value={props.spellGroup.maxSlots}
                        type="number"
                        className='form-control'
                        style={{width: "60px", height: "40px"}}
                        onChange={e => {
                            // props.spellGroup.remainingSlots = (parseInt(e.target.value));
                            props.spellGroup.maxSlots = (parseInt(e.target.value));
                            props.updateSpellGroup(props.spellGroup);
                        }}
                    ></input>
                </div>}
                <div className = "mt-2 mb-2">
                    {props.spellGroup.spells && props.spellGroup.spells.map((spellListItem, index2)=>{return(
                        <button type="button" className="btn btn-link" >
                            {getTranslation(spellListItem.name, props.language)}
                        </button>
                        // <SpellItemComponent 
                        //     editMode={props.editMode}
                        //     isNewSpell={false}
                        //     spellGroup={props.spellGroup}
                        //     spell={props.spellGroup.list[index2]} key={"props.spellGroups-"+props.index+"-spell-"+index2}
                        //     updateSpell={(spell: Spell)=>{
                        //         props.spellGroup.list[index2] = spell;
                        //         props.updateSpellGroup(props.spellGroup);
                        //     }}
                        //     deleteSpell={()=>{
                        //         props.spellGroup.list.splice(index2, 1);
                        //         props.updateSpellGroup(props.spellGroup);
                        //     }}
                        // />
                    )})}
                    <div>
                        <input
                            type="text"
                            className="form-control"
                            placeholder={t("spell-search")+"..."}
                            value={searchValue}
                            onChange={(e) => {
                                let input = e.target.value;
                                setSearchValue(input);
                                let spells = [] as SpellDto[];
                                if (input.length > 0){
                                        spells = allSpells.filter((spell: SpellDto) => getTranslation(spell.name, props.language).toLowerCase().includes(input.toLowerCase()));
                                }
                                setFoundSpells([...spells]);
                            }}
                        ></input>

                        <div className="suggestions" style={{position: "inherit"}}>
                            {foundSpells.length >0  && foundSpells.map((apiSpell :SpellDto, index) => (
                                <div className="suggestion-item" key={index}
                                    onClick={e=>{
                                        // saveSpell(apiSpell);
                                        props.spellGroup.spells.push(apiSpell);
                                        props.updateSpellGroup({...props.spellGroup});
                                        setFoundSpells([...[] as SpellDto[]]);
                                        setSearchValue("");
                                        // props.closeModal();
                                    }}
                                >
                                    {getTranslation(apiSpell.name, props.language)}
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
                {/* <div className="divider-black"></div> */}
        </div>
    </>)
}
export default MonsterSpellGroupComponent;